import { ShadcnReactTable } from '@talentmesh/table';
import { useMemo } from 'react';
import { RoleItemProps, useColumns } from './Hooks/useRolePickerColumns';
import useShadcnTable from '@/Hooks/useShadcnTable';
import UIStrings from '@/Utils/UIStrings';

const rows: RoleItemProps[] = [
    {
        name: UIStrings.Admin,
        description: UIStrings.ThisUserWillHaveFullAccessToTheAccount,
        createRecruitment: true,
        inviteMember: true,
        useAts: true,
        viewApplicants: true,
    },
];

const TeamMemberRolePicker = () => {
    const columns = useColumns();
    const data = useMemo(() => rows, []);

    const table = useShadcnTable({
        columns,
        data,
        getRowId: (row) => row.name,
        enablePagination: false,
        enableBottomToolbar: false,
        enableRowSelection: false,
        enableStickyHeader: false,
        enableTableFooter: false,
        enableColumnDragging: false,
        enableColumnOrdering: false,
        enableColumnPinning: false,
        enableColumnResizing: false,
        manualFiltering: false,
        manualSorting: false,
        manualPagination: false,
        mantinePaperProps: { className: 'rounded-xl shadow-none [&_.mrt-table-container]:w-full' },
    });

    return <ShadcnReactTable table={table} />;
};

export default TeamMemberRolePicker;
